import { expVal } from '@atlassian/jira-feature-experiments';

const JscIssueRankingRelayProvider = {
	get(): boolean {
		return expVal('jsc_list_reranking', 'isRerankingEnabled', false);
	},
};

export default JscIssueRankingRelayProvider;
